<template>
    <div>
        <div role="alert" class="alert alert-danger mb-4" v-show=hideMessage>
            <div class="container">
                <div class="alert-header d-flex align-items-center w-100">
                    <warning class="svg-36 mr-2"></warning>
                    <div class="message-wrapper">
                        <h2 v-html="message"  v-for="message in messages"></h2>
                    </div>
                    <div class="close-icon-right"  @click="hideMessage = false">
                        <closeicon class="svg-36"></closeicon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import closeicon from './icons/circle_close.vue';
import warning from './icons/warning.vue';

export default {
    props: ['messages'],
    components: {closeicon, warning},
    data() {
        return {
            hideMessage: true
        }
    }
}
</script>
